














import { Component, Vue } from 'vue-property-decorator'
import ParallelogramBackground from '@/components/miniComponents/ParallelogramBackground.vue'
import SongDisplay from '@/components/party/currentlyPlaying/SongDisplay.vue'
import VButton from '@/components/miniComponents/VButton.vue'
@Component({
  components: { VButton, SongDisplay, ParallelogramBackground }
})
export default class Home extends Vue {

}
